<template>
  <div id="table">
    <table class="table">
      <tr>
        <td colspan="4" style="text-align: center; background-color: #00308E; color: #FFF">Result</td>
      </tr>
      <tr>
        <td class="text-center" style="background-color: rgb(255, 255, 204)">Date</td>
        <td colspan="3">
          <flat-pickr :config="{time_24hr: true, dateFormat: 'Y-m-d'}" v-model="lotto.lotto_date" placeholder="Date" />
        </td>
      </tr>
      <tr>
        <td class="text-center" style="background-color: rgb(255, 255, 204)">Start</td>
        <td colspan="3">
          <flat-pickr :config="{enableTime: true, enableSeconds: true, time_24hr: true, dateFormat: 'Y-m-d H:i:S'}" v-model="lotto.start_spin" placeholder="Start" />
          <div v-if="invalidStartSpin" class="text-danger text-sm">Please set start time</div>
        </td>
      </tr>
      <tr>
        <td class="text-center" style="background-color: rgb(255, 255, 204)">1ST</td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="prize_1st" v-validate="'numeric|length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 5 digits" maxlength="5" v-model="lotto.results.prize_1st">
          <div class="text-danger text-sm">{{ errors.first('prize_1st') }}</div>
        </td>
        <td class="text-center" style="background-color: rgb(255, 255, 204)">Show 1ST</td>
        <td>
          <flat-pickr v-if="lotto.show_2nd" :config="{enableTime: true, enableSeconds: true, time_24hr: true, dateFormat: 'Y-m-d H:i:S', minDate: minShow1st}" v-model="lotto.show_1st" placeholder="Show 1ST" />
          <em v-else><small>Please set show 2ND</small></em>
        </td>
      </tr>
      <tr>
        <td class="text-center" style="background-color: rgb(255, 255, 204)">2ND</td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="prize_2nd" v-validate="'numeric|length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 5 digits" maxlength="5" v-model="lotto.results.prize_2nd">
          <div class="text-danger text-sm">{{ errors.first('prize_2nd') }}</div>
        </td>
        <td class="text-center" style="background-color: rgb(255, 255, 204)">Show 2ND</td>
        <td>
          <flat-pickr :config="{enableTime: true, enableSeconds: true, time_24hr: true, dateFormat: 'Y-m-d H:i:S', minDate: lotto.start_spin}" v-model="lotto.show_2nd" placeholder="เวลาแสดงผล" />
          <!--<flat-pickr v-if="lotto.results.prize_2nd" :config="{enableTime: true, enableSeconds: true, time_24hr: true, dateFormat: 'Y-m-d H:i:S', minDate: lotto.start_spin}" v-model="lotto.show_2nd" placeholder="เวลาแสดงผล" />
          <em v-else><small>กรอกผล 2ND ก่อน</small></em>-->
        </td>
      </tr>
      <tr>
        <td class="text-center" style="background-color: rgb(255, 255, 204)">3RD</td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="prize_3rd_1" v-validate="'numeric|length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 5 digits" maxlength="5" v-model="lotto.results.prize_3rd_1">
          <div class="text-danger text-sm">{{ errors.first('prize_3rd_1') }}</div>
        </td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="prize_3rd_2" v-validate="'numeric|length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 5 digits" maxlength="5" v-model="lotto.results.prize_3rd_2">
          <div class="text-danger text-sm">{{ errors.first('prize_3rd_2') }}</div>
        </td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="prize_3rd_3" v-validate="'numeric|length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 5 digits" maxlength="5" v-model="lotto.results.prize_3rd_3">
          <div class="text-danger text-sm">{{ errors.first('prize_3rd_3') }}</div>
        </td>
      </tr>
      <tr>
        <td colspan="4" class="text-center" style="background-color: rgb(255, 255, 204)">Special</td>
      </tr>
      <tr>
        <td class="text-center">
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="special_1" v-validate="'required|numeric|length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 5 digits" maxlength="5" v-model="lotto.results.special_1">
          <div class="text-danger text-sm">{{ errors.first('special_1') }}</div>
        </td>
        <td class="text-center">
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="special_2" v-validate="'required|numeric|length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 5 digits" maxlength="5" v-model="lotto.results.special_2">
          <div class="text-danger text-sm">{{ errors.first('special_2') }}</div>
        </td>
        <td class="text-center">
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="special_3" v-validate="'required|numeric|length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 5 digits" maxlength="5" v-model="lotto.results.special_3">
          <div class="text-danger text-sm">{{ errors.first('special_3') }}</div>
        </td>
        <td class="text-center">
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="special_4" v-validate="'required|numeric|length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 5 digits" maxlength="5" v-model="lotto.results.special_4">
          <div class="text-danger text-sm">{{ errors.first('special_4') }}</div>
        </td>
      </tr>
      <tr>
        <td class="text-center">
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="special_5" v-validate="'required|numeric|length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 5 digits" maxlength="5" v-model="lotto.results.special_5">
          <div class="text-danger text-sm">{{ errors.first('special_5') }}</div>
        </td>
        <td class="text-center">
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="special_6" v-validate="'required|numeric|length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 5 digits" maxlength="5" v-model="lotto.results.special_6">
          <div class="text-danger text-sm">{{ errors.first('special_6') }}</div>
        </td>
        <td class="text-center">
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="special_7" v-validate="'required|numeric|length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 5 digits" maxlength="5" v-model="lotto.results.special_7">
          <div class="text-danger text-sm">{{ errors.first('special_7') }}</div>
        </td>
        <td class="text-center">
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="special_8" v-validate="'required|numeric|length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 5 digits" maxlength="5" v-model="lotto.results.special_8">
          <div class="text-danger text-sm">{{ errors.first('special_8') }}</div>
        </td>
      </tr>
      <tr>
        <td colspan="4" class="text-center" style="background-color: rgb(255, 255, 204)">Consolation</td>
      </tr>
      <tr>
        <td class="text-center">
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="consolation_1" v-validate="'required|numeric|length:2'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 2 digits" maxlength="2" v-model="lotto.results.consolation_1">
          <div class="text-danger text-sm">{{ errors.first('consolation_1') }}</div>
        </td>
        <td class="text-center">
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="consolation_2" v-validate="'required|numeric|length:2'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 2 digits" maxlength="2" v-model="lotto.results.consolation_2">
          <div class="text-danger text-sm">{{ errors.first('consolation_2') }}</div>
        </td>
        <td class="text-center">
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="consolation_3" v-validate="'required|numeric|length:2'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 2 digits" maxlength="2" v-model="lotto.results.consolation_3">
          <div class="text-danger text-sm">{{ errors.first('consolation_3') }}</div>
        </td>
        <td class="text-center">
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="consolation_4" v-validate="'required|numeric|length:2'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 2 digits" maxlength="2" v-model="lotto.results.consolation_4">
          <div class="text-danger text-sm">{{ errors.first('consolation_4') }}</div>
        </td>
      </tr>
      <tr>
        <td colspan="5" style="text-align: center;">
          <vs-button class="vs-xs-12" color="success" @click="save">Save</vs-button>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import moment from "moment"

//import Datepicker from 'vuejs-datepicker';

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  name: 'ResultForm',
  components: {
    //Datepicker,
    flatPickr
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      lotto: this.data,
      invalidStartSpin: false
    }
  },
  computed: {
    minShow1st() {
      if (this.lotto.show_2nd)
        return moment(this.lotto.show_2nd).add(5, 'minute').format("YYYY-MM-DD HH:mm:ss")
      else
        return ''
    },
    lottoDate() {
      return this.lotto.lotto_date
    }
  },
  watch: {
    lottoDate(n, o) {
      if(n && n !== o) {
        const spinDate = moment(n).add(1, 'day').format("YYYY-MM-DD")
        const spinTime = moment(this.lotto.start_spin).format("HH:mm:ss")
        this.lotto.start_spin = `${spinDate} ${spinTime}`

        const time1st = moment(this.lotto.show_1st).format("HH:mm:ss")
        this.lotto.show_1st = `${spinDate} ${time1st}`

        const time2nd = moment(this.lotto.show_2nd).format("HH:mm:ss")
        this.lotto.show_2nd = `${spinDate} ${time2nd}`
      }
    }
  },
  methods: {
    save() {
      this.$validator.validate().then(valid => {
        this.invalidStartSpin = this.lotto.start_spin === ''
        if (valid && !this.invalidStartSpin) {
          this.$emit('save', this.lotto)
        }
      })
    }
  }
}

</script>
<style lang="scss">
#table {
  .table {
    width: auto;
    background-color: #FFF;
    border-collapse: collapse;
  }

  .table {
    tr {
      td {
        border:1px solid #00308E !important;

        &:first-child {
          width: 200px;
          font-weight: bold;
        }

        .vs-input--input {
          width: auto;
        }

        input {
          border: 1px solid rgba(0, 0, 0, 0.2);
          color: blue;
        }

        .vdp-datepicker input {
          width: auto;
        }
      }

      td {
        padding: 16px 8px;
        border: 1px solid #DDDDDD;
        border-collapse: collapse;
      }

      .no-boder-r {
        border-right: 0;
      }

      .no-boder-l {
        border-left: 0;
      }

      .no-boder-t {
        border-top: 0;
      }

      .no-boder-b {
        border-bottom: 0;
      }
    }
  }

  .text-center {
    text-align: center;
  }
}

</style>
